module.exports = __webpack_public_path__ + "img/close-black.7477d9a.svg?v=1791296779994";